module.exports = __webpack_public_path__ + "img/pin-notset.8062fa72.svg";